import { useCallback, useEffect } from "react";

const convertTimestamp = (timestamp) => {
  return timestamp ? new Date(timestamp * 1000).toISOString() : null;
};

const getDateFromString = (dateStr) => {
  return dateStr ? { seconds: Math.floor(new Date(dateStr).getTime() / 1000) } : null;
};

const truncate = (str, len = 6, last = false) => {
  const castedInput = str + "";

  if (last) {
    return castedInput
      ? `...${castedInput.substring(castedInput.length - len - 1, castedInput.length - 1)}`
      : castedInput;
  }

  return castedInput ? `${castedInput.substring(0, len)}` : castedInput;
};

const copyText = (str) => {
  try {
    navigator.clipboard.writeText(str);

    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  } catch (e) {
    console.error("Failed to copy text to clipboard:", e);
  }
};

const getFilePath = (str) => {
  if (!str || str.length <= 0) return;
  const arr = str.split("/");
  const last = arr[arr.length - 1];
  const beforeQuery = last.split("?");
  return beforeQuery[0];
};

const filterFullArray = (searchQuery, array) => {
  return array.filter((ele) => {
    return Object.keys(ele).some((key) => {
      const valString = ele[key] + ""; // cast to string
      return valString.toLowerCase().includes(searchQuery.toLowerCase());
    });
  });
};

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const getFullName = (firstName, middleName, lastName) => {
  let mName = " ";
  if (middleName && middleName.length > 0) {
    mName = ` ${middleName[0]}. `;
  }
  return capitalize(firstName) + capitalize(mName) + capitalize(lastName);
};

const useDebouncedEffect = (effect, delay, deps) => {
  const callback = useCallback(effect, [effect, ...deps]);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};

const stringToHslColor = (str, s = 80, l = 30) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let h = hash % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

const isValidEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

const isValidName = (name) => /^([A-Za-z])+$/.test(name);

export {
  stringToHslColor,
  useDebouncedEffect,
  getFullName,
  filterFullArray,
  truncate,
  getDateFromString,
  convertTimestamp,
  getFilePath,
  copyText,
  isValidEmail,
  isValidName
};
